/* eslint-disable import/prefer-default-export */
import { parseData } from '../util/data';
import { apiClient, getBlobApiV2 } from '../util/http';

export const findOrCreateBenefitOrder = async (companyId) => {
  const { data } = await apiClient.post(`/benefit-order/company/${companyId}`);
  return parseData(data);
};

export const findById = async (id) => {
  const { data } = await apiClient.get(`/benefit-order/${id}`);
  return parseData(data);
};

export const saveBenefitOrder = async (id, dataToUpdate) => {
  const { data } = await apiClient.put(`/benefit-order/${id}`, dataToUpdate);
  return parseData(data);
};

export const sendBenefitOrder = async (id, dataToUpdate) => {
  const { data } = await apiClient.post(`/benefit-order/${id}/send`, dataToUpdate);
  return parseData(data);
};

export const findAll = async (params) => {
  const { data } = await apiClient.get(`/benefit-order`, { params });
  return parseData(data);
};

export const process = async (id) => {
  const { data } = await apiClient.post(`/benefit-order/${id}/process`);
  return parseData(data);
};

export const requestReopening = async (id, justification) => {
  const { data } = await apiClient.post(`/benefit-order/${id}/reopening`, { justification });
  return parseData(data);
};

export const denyReopening = async (id, justification) => {
  const { data } = await apiClient.post(`/benefit-order/${id}/deny-reopening`, { justification });
  return parseData(data);
};

export const approveReopening = async (id, payload) => {
  const { data } = await apiClient.post(`/benefit-order/${id}/approve-reopening`, payload);
  return parseData(data);
};

export const downloadDetailXlsxReport = async (id) => getBlobApiV2(`/benefit-order/${id}/export/xlsx`);
